import React, { useState, useEffect, useImperativeHandle, useRef } from "react";
import Select from "react-select"; // Import from react-select
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DoNotDisturbOnRoundedIcon from "@mui/icons-material/DoNotDisturbOnRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

const conditionOptions = [{ value: "win", label: "Win" }, { value: "parity", label: "No Significant Difference" }, { value: "loss", label: "Loss" }];
const logicalOperatorOptions = [
    { label: "AND", value: "AND" },
    { label: "OR", value: "OR" },
];

const FragranceActionStandardKPI = React.forwardRef(function ActionStandardKPI({ tabId, getAsKpiData, options, formData = [], removeKpiCondition = () => { }, validation = {}, coreData, likertScaleData = {} }, ref) {
    const inputRef = useRef(null);
    const inputRefIf = useRef([]);
    const [ifSelects, setIfSelects] = useState([{
        "backend_variable": "",
        "opretor": "",
        "box_analysis": {},
        "expected_result": "",
        "test_name": "",
        "test_title": ""
    }]);

    const [elIfSelects, setElIfSelects] = useState([{
        "backend_variable": "",
        "opretor": "",
        "box_analysis": {},
        "expected_result": "",
        "test_name": "",
        "test_title": ""
    }]);

    const [ifMin, setIfMin] = useState(1);
    const [elIfMin, setElIfMin] = useState(1);
    const [showElIf, setShowElIF] = useState(true);
    const [ren, setRen] = useState(true);
    const [tTestOptions, setTTestOptions] = useState({
        "if": [],
        "elseIf": []
    });

    const method = coreData?.study_type_method__title || null;

    // const [elseExpectedResult, setElseExpectedResult] = useState(method.toLowerCase() === "ict" ? "" : "win");
    const [elseIfOperator, setElseIfOperator] = useState("");
    const [showElseIfOperator, setShowElseIfOperator] = useState(false);
    const [showDisabled, setShowDisabled] = useState(true);

    // Check if any KPI is selected in IF block
    const isIfKpiSelected = ifSelects.some((item) => item?.backend_variable && item.backend_variable.trim() !== "");

    // Sync sample size data from IF to ELSE-IF when ELSE-IF is enabled
    useEffect(() => {
        if (isIfKpiSelected && showElIf && elIfMin === 1 && ifMin !== elIfMin) {
            setElIfMin(ifMin);
        }
    }, [isIfKpiSelected, ifMin, showElIf, elIfMin]);

    useEffect(() => {
        if (ren && formData.length && options.length) {
            const _ifData = formData.filter((ele) => ele?.is_if === true)?.[0];

            if (_ifData) {
                if (_ifData?.kpi.length !== 0) {
                    setIfSelects(_ifData?.kpi);
                    if (_ifData?.kpi.length) {
                        _ifData?.kpi.forEach((ele, i) => {
                            const selectedOption = options?.find(item => item?.value === ele?.backend_variable)
                            const tempOptions = getTTestOptions(selectedOption?.value, selectedOption?.variableCategory);
                            const testOptions = { ...tTestOptions }
                            testOptions["if"][i] = tempOptions;
                            setTTestOptions(testOptions)
                        })
                    }
                }
                setIfMin(_ifData?.min || 1);
            }

            const _elseIfData = formData.filter((ele) => ele?.is_if === false)?.[0];
            if (_elseIfData) {
                if (_elseIfData?.kpi.length !== 0) {
                    setShowElseIfOperator(true);
                    // setElseExpectedResult(_elseIfData?.expected_result)
                    setElseIfOperator(_elseIfData?.kpi?.[0]?.opretor);
                    setElIfSelects(_elseIfData?.kpi);
                    _elseIfData?.kpi.forEach((ele, i) => {
                        const selectedOption = options?.find(item => item?.value === ele?.backend_variable)
                        const tempOptions = getTTestOptions(selectedOption?.value, selectedOption?.variableCategory);
                        const testOptions = { ...tTestOptions }
                        testOptions["elseIf"][i] = tempOptions;
                        setTTestOptions(testOptions)
                    })

                }
                setElIfMin(_elseIfData?.min || 1);
            } else {
                setShowElIF(false);
            }
        }
    }, [formData, ren, options]);

    useImperativeHandle(ref, () => ({
        clearValue() {
            setRen(false);
            if (inputRef.current) {
                inputRef.current.value = ""; // Clears the input's value
            }
            setIfSelects([""]);
            setElIfSelects([""]);
            setElseIfOperator("");
            setShowElseIfOperator(false);
        },
    }));

    // useEffect(() => {
    //     let ifKpi = ifSelects.map((ele) => ele.kpi?.value).filter(Boolean);
    //     let elIfKpi = elIfSelects.map((ele) => ele.kpi?.value).filter(Boolean);
    //     let payload = [];

    //     payload.push({
    //         kpi: ifKpi,
    //         min: parseInt(ifMin),
    //         max: parseInt(ifKpi.length),
    //         expected_result: conditionOptions[0]?.value,
    //         is_if: true
    //     });

    //     if(showElIf){

    //         payload.push({
    //             kpi: elIfKpi,
    //             min: parseInt(elIfMin),
    //             max: parseInt(elIfKpi.length),
    //             expected_result: elIfCondition?.value,
    //             is_if: false
    //         });

    //     }
    //     getAsKpiData(tabId, payload);
    // }, [ifSelects, elIfSelects, ifMin, elIfMin, ifCondition, elIfCondition]);

    // useEffect(() => {
    //     if (formData?.length > 0) {
    //         if(formData.length === 1){
    //             setShowElIF(false);
    //         }
    //         formData?.forEach((datum) => {
    //             const kpiData = datum?.kpi != "" ? JSON.parse(datum?.kpi) : [""];
    //             if(datum.is_if){
    //                 let ifKpis = kpiData.map((ele) => {
    //                     return { kpi: options?.find(obj => obj.value === ele) }
    //                 });

    //                 setIfSelects(ifKpis);
    //                 setIfMin(datum.min);
    //                 setIfCondition(conditionOptions.find(obj => obj.value === datum.expected_result));
    //             } else {
    //                 let elIfKpis = kpiData.map((ele) => {
    //                     return { kpi: options?.find(obj => obj.value === ele) }
    //                 });
    //                 setElIfSelects(elIfKpis);
    //                 setElIfMin(datum.min);
    //                 setElIfCondition(conditionOptions.find(obj => obj.value === datum.expected_result));
    //             }
    //         });

    //     }
    // }, [options])

    const handleAddSelect = (type) => {
        // Add a new Select component to the current state
        const obj = {
            "backend_variable": "",
            "opretor": "",
            "box_analysis": {},
            "expected_result": "",
            "test_name": "",
            "test_title": ""
        };
        if (type === "if") {
            setIfSelects([...ifSelects, obj]);
        } else {
            setElIfSelects([...elIfSelects, obj]);
        }
    };

    const handleSelectChange = (value, index, type, block, remove = false) => {
        setRen(false);
        if (remove) {
            if (block === "if") {
                if (ifSelects.length <= ifMin) {
                    setIfMin(1);
                }
                const val = ifSelects.filter((_, i) => i !== index);
                setIfSelects(val);

                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == true)?.[0] || {}));
                obj["expected_result"] = conditionOptions[0].value;
                obj["is_if"] = true;
                obj["min"] = 1;
                obj["kpi"] = val.map((ele) => ele).filter(Boolean);
                obj["max"] = val.map((ele) => ele).filter(Boolean).length;
                getAsKpiData(tabId, obj, true);
                const testOptions = { ...tTestOptions }
                const tempArr = testOptions["if"]?.filter((_, i) => i !== index);
                testOptions["if"] = tempArr;
                setTTestOptions(testOptions);
            } else {
                if (elIfSelects.length <= elIfMin) {
                    setElIfMin(1);
                }

                const val = elIfSelects.filter((_, i) => i !== index);
                setElIfSelects(val);

                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == false)?.[0] || {}));
                obj["expected_result"] = conditionOptions[0].value;
                obj["is_if"] = false;
                obj["min"] = 1;
                obj["kpi"] = val.map((ele) => ele).filter(Boolean);
                obj["max"] = val.map((ele) => ele).filter(Boolean).length;
                getAsKpiData(tabId, obj, false);
                const testOptions = { ...tTestOptions }
                const tempArr = testOptions["elseIf"]?.filter((_, i) => i !== index);
                testOptions["elseIf"] = tempArr;
                setTTestOptions(testOptions);
            }
            getFilteredOptions();
        } else {
            if (block === "if") {
                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == true)?.[0] || {}));
                const kpiObj = obj?.kpi || [];
                obj["expected_result"] = "";
                obj["is_if"] = true;
                obj["min"] = ifMin;
                obj["max"] = kpiObj.length;
                const temp = {
                    backend_variable: "",
                    opretor: "",
                    box_analysis: {},
                    expected_result: "",
                    test_name: "",
                    test_title: ""
                };
                let tempObj = kpiObj[index] || temp;
                const val = value.value;
                if (type === "selectKpi") {
                    tempObj["backend_variable"] = val;
                    tempObj["test_name"] = "";
                    tempObj["test_title"] = "";
                    tempObj["box_analysis"] = {};
                    const tempOptions = getTTestOptions(val, value.variableCategory);

                    const testOptions = { ...tTestOptions };
                    testOptions[block] = [...(testOptions[block] || [])];
                    testOptions[block][index] = tempOptions;
                    setTTestOptions(testOptions);
                }
                else if (type === "tTest") {
                    tempObj["test_name"] = val;
                    tempObj["test_title"] = value.label;
                    const bvObj = kpiObj[index];
                    const bv = options.find((ele) => ele.value === bvObj.backend_variable);
                    if (method?.toLowerCase() === "ict") {
                        tempObj["box_analysis"] = {};
                    } else {
                        tempObj["box_analysis"] = tempObj["box_analysis"] || {};
                        const keyName = bv?.value || tempObj["backend_variable"];
                        if (!tempObj["box_analysis"][keyName]) {
                            tempObj["box_analysis"][keyName] = {};
                        }
                        if (value?.key && value?.analysis !== undefined) {
                            tempObj["box_analysis"][keyName][value.key] = value.analysis;
                        }
                    }
                } else if (type === "operator") {
                    tempObj["opretor"] = val;
                } else if (type === "result") {
                    tempObj["expected_result"] = val;
                }
                kpiObj[index] = tempObj;
                setIfSelects([...kpiObj]);
                obj["kpi"] = kpiObj;
                getAsKpiData(tabId, obj, true);
            } else if (block === "elseIf") {
                const obj = JSON.parse(JSON.stringify(formData.filter((ele) => ele?.is_if == false)?.[0] || {}));
                const kpiObj = obj?.kpi || [];
                // Sync root expected_result to KPI item if it has a default value
                if (obj["expected_result"] && kpiObj.length > 0 && !kpiObj[0]?.expected_result) {
                    kpiObj[0]["expected_result"] = obj["expected_result"];
                }
                // obj["expected_result"] = "";
                obj["is_if"] = false;
                obj["min"] = elIfMin;
                obj["max"] = kpiObj.length;
                const temp = {
                    backend_variable: "",
                    opretor: "",
                    box_analysis: {},
                    expected_result: "",
                    test_name: "",
                    test_title: ""
                };
                let tempObj = kpiObj[index] || temp;

                if (type === "inputMin") {
                    setElIfMin(value);
                    obj["min"] = parseInt(value);
                }

                const val = value.value;
                if (type === "selectKpi") {
                    tempObj["backend_variable"] = val;
                    tempObj["test_name"] = "";
                    tempObj["test_title"] = "";
                    tempObj["box_analysis"] = {};
                    const tempOptions = getTTestOptions(val, value.variableCategory);
                    const testOptions = { ...tTestOptions };
                    testOptions[block] = [...(testOptions[block] || [])];
                    testOptions[block][index] = tempOptions;
                    setTTestOptions(testOptions);
                }
                else if (type === "tTest") {
                    tempObj["test_name"] = val;
                    tempObj["test_title"] = value.label;
                    const bvObj = kpiObj[index];
                    const bv = options.find((ele) => ele.value === bvObj?.backend_variable);
                    if (method?.toLowerCase() === "ict") {
                        tempObj["box_analysis"] = {};
                    } else {
                        tempObj["box_analysis"] = tempObj["box_analysis"] || {};
                        const keyName = bv?.value || tempObj["backend_variable"];
                        if (!tempObj["box_analysis"][keyName]) {
                            tempObj["box_analysis"][keyName] = {};
                        }
                        if (value?.key && value?.analysis !== undefined) {
                            tempObj["box_analysis"][keyName][value.key] = value.analysis;
                        }
                    }
                } else if (type === "operator") {
                    tempObj["opretor"] = val;
                    setElseIfOperator(val);
                } else if (type === "result") {
                    tempObj["expected_result"] = val;
                    obj["expected_result"] = val
                    // setElseExpectedResult(val);
                }
                kpiObj[index] = tempObj;
                setElIfSelects([...kpiObj]);
                obj["kpi"] = kpiObj;
                getAsKpiData(tabId, obj, false);
            }
        }
    };

    const renderAddRemoveKPIButtons = (type, index, selects) => {
        let buttons = "";
        if (selects.length === 1) {
            if (type === "if") {
                // if (showElIf) {
                //     buttons = "";
                // } else {
                buttons = (
                    <IconButton
                        onClick={() => handleAddSelect(type)}
                        aria-label="add"
                        sx={{
                            color: "rgb(51, 94, 234) !important",
                        }}
                    >
                        <AddCircleRoundedIcon
                            style={{
                                fontSize: 20,
                            }}
                        />
                    </IconButton>
                );
                // }
            } else {
                buttons = (
                    <IconButton
                        onClick={() => handleAddSelect(type)}
                        aria-label="add"
                        sx={{
                            color: "rgb(51, 94, 234) !important",
                        }}
                    >
                        <AddCircleRoundedIcon
                            style={{
                                fontSize: 20,
                            }}
                        />
                    </IconButton>
                );
            }
        } else {
            if (index === selects.length - 1) {
                buttons = (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                        }}
                    >
                        <IconButton
                            onClick={() => handleSelectChange(null, index, null, type, true)}
                            aria-label="close"
                            sx={{
                                color: "#ff0000b8 !important",
                            }}
                        >
                            <DoNotDisturbOnRoundedIcon
                                style={{
                                    fontSize: 20,
                                }}
                            />
                        </IconButton>
                        <IconButton
                            onClick={() => handleAddSelect(type)}
                            aria-label="add"
                            sx={{
                                color: "rgb(51, 94, 234) !important",
                            }}
                        >
                            <AddCircleRoundedIcon
                                style={{
                                    fontSize: 20,
                                }}
                            />
                        </IconButton>
                    </div>
                );
            } else {
                buttons = (
                    <IconButton
                        onClick={() => handleSelectChange(null, index, null, type, true)}
                        aria-label="close"
                        sx={{
                            color: "#ff0000b8 !important",
                        }}
                    >
                        <DoNotDisturbOnRoundedIcon
                            style={{
                                fontSize: 20,
                            }}
                        />
                    </IconButton>
                );
            }
        }

        return buttons;
    };

    const handleAddRemoveCondition = (param) => {
        setElIfSelects([""]);
        setElIfMin(1);
        setShowElIF(param);
        let obj = {};
        if (param) {
            obj["expected_result"] = "";
            obj["is_if"] = false;
            obj["min"] = 1;
            obj["max"] = 1;
            obj["kpi"] = [""];
        }
        removeKpiCondition(tabId, param, obj);
    };

    const getFilteredOptions = (currentIndex = null, block = null) => {
        let selectedOptions = [];

        ifSelects?.forEach((ele, i) => {
            if (block === "if" && i === currentIndex) return;
            if (ele?.backend_variable) selectedOptions.push(ele.backend_variable);
        });

        elIfSelects?.forEach((ele, i) => {
            if (block === "elseIf" && i === currentIndex) return;
            if (ele?.backend_variable) selectedOptions.push(ele.backend_variable);
        });

        return options?.filter((datum) => !selectedOptions.includes(datum.value));
    };

    const getTTestOptions = (backendVariable, variableCategory) => {
        let testOptions = [];
        if (method) {
            if (method.toLowerCase() === "ict") {
                if (variableCategory === "Fragrance Metrics Analysis") {
                    testOptions = [
                        { label: "Fisher's LSD pairwise comparisons", value: "fragrance fisher's lsd pairwise comparisons" },
                    ];
                } else {
                    testOptions = [
                        { label: "Binomial (P Value Two Sided​)", value: "non-parametric binomial test" },
                        { label: "Z Test", value: "preference_analysis z test" },
                    ];
                }
            } else if (method.toLowerCase() === "clt") {
                if (variableCategory === "JAR") {
                    testOptions = [
                        { label: "Z Test (Top 2 Box)", value: "z test" },
                        { label: "Z Test (Middle Box)", value: "z test" },
                        { label: "Z Test (Bottom 2 Box)", value: "z test" }
                    ];
                } else {
                    testOptions = [{ label: "Student's T Test Comparisons", value: "student's t test comparisons" }];
                    const boxanalysisOptions = getBoxAnalysisOptions(likertScaleData[backendVariable], "z test");
                    testOptions.push(...boxanalysisOptions);
                }
            } else {
                if (variableCategory === "Fragrance Metrics Analysis") {
                    testOptions = [
                        { label: "Student's T Test Comparisons", value: "student's t test comparisons" },
                    ];
                    const boxanalysisOptions = getBoxAnalysisOptions(likertScaleData[backendVariable], "z test");
                    testOptions.push(...boxanalysisOptions);
                } else {
                    testOptions = [
                        { label: "Binomial (P Value Two Sided​)", value: "non-parametric binomial test" },
                        { label: "Z Test", value: "product_preference z test" },
                    ];
                }

            }
        }
        return testOptions;
    };

    function getBoxAnalysisOptions(scale, testName) {
        const result = [];

        for (let rank = 1; rank < scale; rank++) {
            if (rank === 1) {
                result.push({ label: `${testName} (Top ${rank} (${scale}))`, value: testName, analysis: rank, key: "top" });
            } else {
                const secondValue = scale - (rank - 1);
                const operator = rank === 2 ? "&" : "-";

                result.push({
                    label: `${testName} (Top ${rank} (${scale}${operator}${secondValue}))`,
                    value: testName,
                    analysis: rank,
                    key: "top"
                });
            }
        }

        return result;
    }

    useEffect(() => {
        const elseIfData = formData.find(item => item.is_if === false);

        const isEmptyElseIf =
            elseIfData?.kpi?.length === 1 &&
            elseIfData?.kpi?.[0] === "";

        if (formData.length > 1 && !isEmptyElseIf) {
            setShowDisabled(false)
        } else {
            setShowDisabled(true);
            setShowElseIfOperator(false);
        }
    }, [formData]);

    const handleAddElseIfOperator = () => {
        setShowElseIfOperator(true);
    };

    return (
        <div
            style={{
                background: "#fff",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <label className="as-kpi-header liner-light-blue-background-2">KPI Selection Criteria</label>
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px",
                    border: "1px solid #e8e8e8",
                    marginBottom: "10px",
                }}
            >
                {ifSelects.map((select, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "10px",
                        }}
                    >
                        {/* IF / AND OR */}
                        <div
                            style={{
                                width: "10%",
                                textAlign: "center",
                            }}
                        >
                            {index === 0 ? (
                                <>
                                    <label className="as-kpi-label">IF</label>
                                    {!showElIf && ifSelects.length === 1 ? (
                                        <button
                                            style={{
                                                background: "grey",
                                                outline: "none",
                                                border: "none",
                                                color: "#fff",
                                                minHeight: "30px",
                                                padding: "5px",
                                                marginTop: "5px",
                                                width: "100%",
                                            }}
                                            onClick={() => handleAddRemoveCondition(true)}
                                        >
                                            Add Condition
                                        </button>
                                    ) : (
                                        ""
                                    )}
                                </>
                            ) : (
                                <>
                                    <Select
                                        className="dialogue-dropdown"
                                        value={logicalOperatorOptions.filter(
                                            (ele) => ele.value === ifSelects[index].opretor)
                                        }
                                        options={logicalOperatorOptions}
                                        onChange={(e) =>
                                            handleSelectChange(e, index, "operator", "if")
                                        }
                                    />
                                    <span style={{ color: "#FF0000", display: "block", marginTop: 4 }}>
                                        {validation?.ifObj?.items?.[index]?.opretor || ""}
                                    </span>
                                </>
                            )}
                        </div>

                        {/* KPI */}
                        <div style={{ width: "25%", margin: "0 10px" }}>
                            <Select
                                key={inputRefIf[index]}
                                className="dialogue-dropdown"
                                options={getFilteredOptions(index, "if")}
                                value={options.filter(
                                    (ele) => ele.value === ifSelects[index]?.backend_variable
                                )}
                                placeholder={`KPI ${index + 1}`}
                                onChange={(e) =>
                                    handleSelectChange(e, index, "selectKpi", "if")
                                }
                                isSearchable
                                filterOption={(option, inputValue) => {
                                    if (!inputValue) return true;

                                    const firstChild = option.label?.props?.children?.[0];

                                    const labelText =
                                        typeof firstChild === "string"
                                            ? firstChild.toLowerCase()
                                            : "";

                                    return labelText.includes(inputValue.toLowerCase());
                                }}
                            />
                            <span style={{ color: "#FF0000" }}>
                                {validation?.ifObj?.items?.[index]?.kpi || ""}
                            </span>
                        </div>

                        {/* TYPE LABEL */}
                        <div style={{ width: "10%", textAlign: "center" }}>
                            <label>Type Of T-test</label>
                        </div>

                        {/* T-TEST */}
                        <div style={{ width: "25%", margin: "0 10px" }}>
                            <Select
                                className="dialogue-dropdown"
                                value={
                                    tTestOptions["if"]?.[index]?.find(ele => ele.label === ifSelects[index].test_title) ||
                                    (ifSelects[index]?.test_title ? { label: ifSelects[index].test_title, value: ifSelects[index].test_name } : null)
                                }
                                options={tTestOptions["if"]?.[index]}
                                getOptionValue={(option) => option.label}
                                onChange={(e) =>
                                    handleSelectChange(e, index, "tTest", "if")
                                }
                            />
                            <span style={{ color: "#FF0000" }}>
                                {validation?.ifObj?.items?.[index]?.test_name || ""}
                            </span>
                        </div>

                        {/* BUTTON */}
                        <div style={{ width: "8%" }}>
                            {renderAddRemoveKPIButtons("if", index, ifSelects)}
                        </div>

                        {/* IS */}
                        <div style={{ width: "5%", textAlign: "center" }}>
                            <label>IS</label>
                        </div>

                        {/* RESULT */}
                        <div style={{ width: "25%", margin: "0 10px" }}>
                            <Select
                                className="dialogue-dropdown"
                                value={conditionOptions.filter(
                                    (ele) => ele.value === ifSelects[index]?.expected_result)
                                }
                                options={method.toLowerCase() === "ict" ? conditionOptions : [conditionOptions[0]]}
                                onChange={(e) => handleSelectChange(e, index, "result", "if")}
                            />
                            <span style={{ color: "#FF0000" }}>
                                {validation?.ifObj?.items?.[index]?.expected_result || ""}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            {showElIf ? (
                <>
                    <div
                        style={{
                            display: "flex",
                            margin: "10px"
                        }}
                    >
                        <IconButton
                            onClick={handleAddElseIfOperator}
                            disabled={showDisabled}
                            aria-label="add"
                            sx={{
                                color: showDisabled ? "rgb(192, 192, 192) !important" : "rgb(51, 94, 234) !important",
                            }}
                        >
                            <AddCircleRoundedIcon
                                style={{
                                    fontSize: 20,
                                }}
                            />
                        </IconButton>
                        {showElseIfOperator ? (
                            <div
                                style={{
                                    maxWidth: "100px",
                                }}
                            >
                                <Select
                                    className="dialogue-dropdown"
                                    value={logicalOperatorOptions.filter(
                                        (ele) => ele.value === elseIfOperator)
                                    }
                                    options={logicalOperatorOptions}
                                    onChange={(e) =>
                                        handleSelectChange(e, 0, "operator", "elseIf")
                                    }
                                    isDisabled={!isIfKpiSelected}
                                />
                                <span style={{ color: "#FF0000", display: "block", marginTop: 4 }}>
                                    {validation?.elseIfObj?.items?.[0]?.opretor || ""}
                                </span>
                            </div>
                        ) : (<span style={{ color: "#FF0000", display: "block", marginTop: 4 }}>
                            {validation?.elseIfObj?.items?.[0]?.opretor || ""}
                        </span>
                        )
                        }
                    </div>
                    <div className="condition-block">
                        <IconButton
                            onClick={() => handleAddRemoveCondition(false)}
                            aria-label="close"
                            sx={{
                                position: "relative",
                                right: 0,
                                color: "#ff0000b8 !important",
                            }}
                            style={{
                                position: "absolute",
                                top: "-20px",
                                right: "-20px",
                            }}
                        >
                            <CancelRoundedIcon
                                style={{
                                    fontSize: 25,
                                }}
                            />
                        </IconButton>
                        <div
                            style={{
                                display: "flex",
                                padding: "10px",
                                border: "1px solid #e8e8e8",
                                alignItems: "center",
                                flexDirection: "row",
                            }}
                        >
                            <div
                                className="as-kpi-label"
                                style={{
                                    width: "10%",
                                }}
                            >
                                <label>Else IF</label>
                            </div>
                            <div
                                style={{
                                    width: "72%",
                                    margin: "0px 10px",
                                    // alignItems: "center"
                                }}
                            >
                                {elIfSelects.map((select, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginBottom: elIfSelects.length > 1 ? "10px" : "0px",
                                        }}
                                    >
                                        <div style={{ width: "50%" }}>
                                            <Select
                                                key={inputRef}
                                                className="dialogue-dropdown"
                                                options={getFilteredOptions(index, "elseIf")}
                                                value={options.filter((ele) => ele.value === elIfSelects[index]?.backend_variable)}
                                                placeholder={`KPI ${index + 1}`}
                                                onChange={(e) => handleSelectChange(e, index, "selectKpi", "elseIf")}
                                                isDisabled={!isIfKpiSelected}
                                                isSearchable
                                                filterOption={(option, inputValue) => {
                                                    if (!inputValue) return true;

                                                    const firstChild = option.label?.props?.children?.[0];

                                                    const labelText =
                                                        typeof firstChild === "string"
                                                            ? firstChild.toLowerCase()
                                                            : "";

                                                    return labelText.includes(inputValue.toLowerCase());
                                                }}
                                            />
                                            <span
                                                style={{
                                                    color: "#FF0000",
                                                    margin: "2px 5px",
                                                }}
                                            >
                                                {validation?.elseIfObj?.items?.[index]?.kpi || ""}
                                            </span>
                                        </div>

                                        {/* TYPE LABEL */}
                                        <div style={{ width: "20%", marginLeft: "10px", textAlign: "center" }}>
                                            <label>Type Of T-test</label>
                                        </div>

                                        {/* T-TEST */}
                                        <div style={{ width: "50%", margin: "0 10px" }}>
                                            <Select
                                                className="dialogue-dropdown"
                                                value={
                                                    tTestOptions["elseIf"]?.[index]?.find(ele => ele.label === elIfSelects[index].test_title) ||
                                                    (elIfSelects[index]?.test_title ? { label: elIfSelects[index].test_title, value: elIfSelects[index].test_name } : null)
                                                }
                                                options={elIfSelects[index]?.backend_variable ? tTestOptions["elseIf"]?.[index] : []}
                                                getOptionValue={(option) => option.label}
                                                onChange={(e) => handleSelectChange(e, index, "tTest", "elseIf")}
                                                isDisabled={!isIfKpiSelected}
                                            />
                                            <span
                                                style={{
                                                    color: "#FF0000",
                                                    margin: "2px 5px",
                                                    display: "block",
                                                }}
                                            >
                                                {validation?.elseIfObj?.items?.[index]?.test_name || ""}
                                            </span>
                                        </div>

                                        {/* Button to remove the corresponding select component */}
                                        <div style={{ width: "17%", padding: "3px" }}>{renderAddRemoveKPIButtons("elseIf", index, elIfSelects)}</div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    width: elIfSelects.length === 1 ? "5%" : "35%",
                                    textAlign: "center",
                                    alignItems: "center"
                                }}
                            >
                                {elIfSelects.length === 1 ? (
                                    <label>IS</label>
                                ) : (
                                    <>
                                        <div
                                            style={{
                                                display: "flex",
                                            }}
                                        >
                                            <label
                                                style={{
                                                    width: "30%",
                                                    textAlign: "center",
                                                    padding: "10px",
                                                }}
                                            >
                                                ATLEAST
                                            </label>
                                            <input
                                                ref={inputRef}
                                                type="text"
                                                name="elIfMin"
                                                className="text-input-dialog as-input-field"
                                                placeholder=""
                                                disabled={!isIfKpiSelected}
                                                value={elIfMin}
                                                onChange={(e) => handleSelectChange(e.target.value, null, "inputMin", "elseIf")}
                                                style={{
                                                    width: "35%",
                                                }}
                                            />
                                            <label
                                                style={{
                                                    width: "40%",
                                                    textAlign: "center",
                                                    padding: "10px",
                                                }}
                                            >
                                                OUT OF
                                            </label>
                                            <input
                                                type="text"
                                                name="ifMin"
                                                className="text-input-dialog as-input-field"
                                                placeholder=""
                                                disabled={true}
                                                value={elIfSelects.length}
                                                style={{
                                                    width: "35%",
                                                }}
                                            />
                                        </div>
                                        <span
                                            style={{
                                                color: "#FF0000",
                                                margin: "2px 5px",
                                            }}
                                        >
                                            {validation && validation.elseIfObj && validation.elseIfObj.min ? validation.elseIfObj.min : ""}
                                        </span>
                                    </>
                                )}
                            </div>
                            <div
                                style={{
                                    width: elIfSelects.length === 1 ? "25%" : "10%",
                                    margin: "0px 10px",
                                    marginBottom: elIfSelects.length === 1 ? "0px" : "17px",
                                }}
                            >
                                <Select
                                    className="dialogue-dropdown"
                                    name={"elIfCondition"}
                                    value={conditionOptions.filter(
                                        (ele) => ele.value === elIfSelects[0]?.expected_result)
                                    }
                                    options={method.toLowerCase() === "ict" ? conditionOptions : [conditionOptions[0]]}
                                    onChange={(e) => handleSelectChange(e, 0, "result", "elseIf")}
                                    isDisabled={!isIfKpiSelected}
                                />
                                <span
                                    style={{
                                        color: "#FF0000",
                                        margin: "2px 5px",
                                        display: "block",
                                    }}
                                >
                                    {validation?.elseIfObj?.items?.[0]?.expected_result || ""}
                                </span>
                            </div>
                        </div>
                    </div>
                </>

            ) : (
                ""
            )}
        </div>
    );
});

FragranceActionStandardKPI.propTypes = {
    tabId: PropTypes.number,
    getAsKpiData: PropTypes.func,
    options: PropTypes.array,
    formData: PropTypes.array,
    // error: PropTypes.object,
    removeKpiCondition: PropTypes.func,
    validation: PropTypes.object,
    coreData: PropTypes.object,
    likertScaleData: PropTypes.object
};

export default FragranceActionStandardKPI;
